import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './index';

const pageTitleMap = [
  { regex: /^\/$/, title: 'Dashboard' },
  { regex: /^\/content/, title: 'Content' },
  { regex: /^\/users\//, title: 'User' },
  { regex: /^\/users$/, title: 'Users' },
  { regex: /^\/tings\//, title: 'Edit Ting' },
  { regex: /^\/tings$/, title: 'Tings' },
  { regex: /^\/posttests/, title: 'Post Tests' },
  { regex: /^\/newposttest/, title: 'New Post Test' },
  { regex: /^\/test\//, title: 'Edit Post Test' },
  { regex: /^\/whatsapp-parks/, title: 'WhatsApp Groups' },
  { regex: /^\/settings/, title: 'Settings' },
  { regex: /^\/login/, title: 'Login' },
  { regex: /^\/register/, title: 'Register' },
];

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    const match = pageTitleMap.find((m) => m.regex.test(location.pathname));
    document.title = match ? match.title : 'Latest Sightings Admin Panel';
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default Analytics;
